import { cn } from '@goaltree/ui/lib/utils'
import { AlignLeft, Grid3x3, LayoutList } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { IconTip } from '@/components/icon-tip'

// Compact ⇄ detailed switch: shows the view you'd switch to.
export function DensityToggle({
  compact,
  onToggle,
  className,
}: {
  compact: boolean
  onToggle: () => void
  className?: string
}) {
  const { t } = useTranslation()
  const label = t(compact ? 'common.detailed' : 'common.compact')
  return (
    <IconTip label={label}>
      <button
        type="button"
        onClick={onToggle}
        aria-label={label}
        className={cn(
          'flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground',
          className,
        )}
      >
        {compact ? (
          <LayoutList className="h-5 w-5" strokeWidth={1.5} />
        ) : (
          <AlignLeft className="h-5 w-5" strokeWidth={1.5} />
        )}
      </button>
    </IconTip>
  )
}

export type Density = 'compact' | 'detailed' | 'dots'

// Today's three-way switch; like DensityToggle it shows the view you'd switch to.
export function DensityCycle({
  density,
  onNext,
  className,
}: {
  density: Density
  onNext: () => void
  className?: string
}) {
  const { t } = useTranslation()
  const label = t(
    density === 'compact'
      ? 'common.detailed'
      : density === 'detailed'
        ? 'common.dotGrids'
        : 'common.compact',
  )
  const Icon = density === 'compact' ? LayoutList : density === 'detailed' ? Grid3x3 : AlignLeft
  return (
    <IconTip label={label}>
      <button
        type="button"
        onClick={onNext}
        aria-label={label}
        className={cn(
          'flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground',
          className,
        )}
      >
        <Icon className="h-5 w-5" strokeWidth={1.5} />
      </button>
    </IconTip>
  )
}
